import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { SLLayer } from '../sl-layer';
import { CancellablePromise } from 'src/app/types/cancellable-promise';
import { GeometryObject } from '@turf/turf';


export type StorageServicesListHandler = (list: Array<StorageServiceItem>) => void;

export type StoragePath = {
	[pathName: string]: string;
}

export type StorageServiceItem = {
	service_id: string;
	service_name: string;
	paths: Array<StoragePath>

}
@Injectable({
	providedIn: 'root'
})
export class StorageService {

	constructor(private wapi: SlWapiService) {
	}

	GetOrgStorageServices(layerId: any, handler: StorageServicesListHandler | null) {
		return this.wapi.Post('organization/storage/list/', { layer: layerId }, true).then((reply) => {
			const response = reply.response;
			if (response.status === 'ok') {
				handler(response.results);
				return;
			};
			handler(null);
		});
	}

}
